import type { DataSourceAbstract, FormContainerBlockConfig } from '@lighthouse/core'
import { ActionItemPattern, ALIGNMENT, DIRECTION, FLEX_ALIGN } from '@lighthouse/core'
import { generateJson } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'

import { getInitButton } from './button'
/**
 * 生成表单容器的配置
 *
 * @param {(undefined | DataSourceAbstract)} dataSource
 * @returns {FormContainerBlockConfig}
 */
export const generateFormContainerBlock = (
    mainBreakPoint: string,
    dataSource: undefined | DataSourceAbstract
): FormContainerBlockConfig => {
    const actionId = nanoid()
    return {
        pointer: dataSource ? dataSource.id : '',
        submitButton: {
            ...getInitButton(ActionItemPattern.primary),
            name: generateJson('提交'),
            pattern: ActionItemPattern.primary,
            showType: 'name',
            size: 'lg',
            radius: '8',
            align: ALIGNMENT.left
        },
        updateType: 'SUBMIT',
        submitType: 'CREATE',
        eventList: [],
        collectEvents: [],
        rules: [],
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            },
            layout: {
                align: {
                    direction: DIRECTION.vertical,
                    alignX: FLEX_ALIGN['flex-start'],
                    alignY: FLEX_ALIGN['flex-start']
                },
                gap: {
                    size: 8,
                    unit: 'px'
                },
                padding: { size: [4, 4, 4, 4], unit: 'px' }
            },
            design: {}
        },
        breakPoints: []
    }
}
